/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostResponsiveFileRequest
 */
export interface PostResponsiveFileRequest {
    /**
     * 
     * @type {string}
     * @memberof PostResponsiveFileRequest
     */
    caseFileId: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostResponsiveFileRequest
     */
    isWithheld: boolean;
}

export function PostResponsiveFileRequestFromJSON(json: any): PostResponsiveFileRequest {
    return PostResponsiveFileRequestFromJSONTyped(json, false);
}

export function PostResponsiveFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostResponsiveFileRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseFileId': json['caseFileId'],
        'isWithheld': json['isWithheld'],
    };
}

export function PostResponsiveFileRequestToJSON(value?: PostResponsiveFileRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseFileId': value.caseFileId,
        'isWithheld': value.isWithheld,
    };
}


